<template>
  <div class="modalFormWrap">
    <div class="realAvatarWrap">
      <div>
        <input class="fileBtn" @change="beforeUpload" type="file" name="files" />
        <Button class="defaultBtn formBtn size12" shape="circle">{{newInfo?'更换':'上传'}}真实头像</Button>
        <div v-if="newInfo" class="floatRight">
          <span class="smallerBtn" @click="changeScale(-1)"></span>
          <span class="largerBtn" @click="changeScale(1)"></span>
        </div>
        <div class="avatar">
          <vue-cropper 
            v-if="newInfo"
            ref="cropper" 
            :img="newInfo" 
            :fixedBox="true" 
            :autoCrop="true" 
            :info="false"
            @realTime="realTime" />
        </div>
      </div>
      <div v-if="newInfo" class="rightAvatar">
        <p class="size12">预览头像实际使用尺寸</p>
        <div class="realSize">
          <div :style="previewStyle">
            <div :style="previews.div">
              <img :src="previews.url" :style="previews.img">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnWrap">
      <Button class="defaultBtn formBtn" shape="circle" :loading="submitting" @click="submit">保存并跳转至填写个人信息</Button>
    </div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import centerService from '@/api/center'
export default {
  props: ['info'],
  components: {
    VueCropper
  },
  data(){
    return{
      newInfo: null,
      previewStyle: {},
      previews: {},
      submitting: false
    }
  },
  mounted(){
    if(this.info){
      this.newInfo = this.getImageUrl(this.info)
    }
    // console.log(this.newInfo)
  },
  methods:{
    // 获取图片信息
    beforeUpload(e){
      let input = e.target, files = input.files
      if(files && files[0]){
        let file = files[0]
        if(file.size>2*1024*1024){
          input.value = ''
          this.$Message.info('图片不能大于2M，请重新选择')
        }else{
          let reader = new FileReader();
          reader.onload = (ev) => {
            let data
            if (typeof ev.target.result === 'object') {
              // 把Array Buffer转化为blob 如果是base64不需要 
              data = window.URL.createObjectURL(new Blob([ev.target.result]))
            } else {
              data = ev.target.result
            }
            this.newInfo = data
          }
          // 转化为base64 
          // reader.readAsDataURL(file) 
          // 转化为blob 
          reader.readAsArrayBuffer(file)
          return false
        }
      }
    },
    // 修改图片大小
    changeScale(i) {
      this.$refs.cropper.changeScale(i)
    },
    // 预览
    realTime(data) {
      this.previewStyle = {
        width: data.w + "px",
        height: data.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: 80 / data.w
      }
      this.previews = data
    },
    // 上传并跳转
    submit(){
      // console.log(this.$refs.cropper)
      if(!this.$refs.cropper){
        this.$Message.error('请上传头像')
        return
      }
      this.submitting = true
      this.$refs.cropper.getCropBlob((blob) => {
        // do something
        let data = new FormData()
        //   name = this.fileImg.name || this.img.name,
        //   l = name.length;
        // if (l > 32) {
        //   name = name.substring(l - 32);
        // }
        data.append("avatar", blob)
        data.append("applyType", 'AVATAR')
        centerService.uploadAvatar(data).then(res => {
            if (res.errorNo === 0) {
              let avatar = res.data,
                  userInfo = this.$store.getters.userInfo,
                  info = {accountId: userInfo.accountId, userId: userInfo.id, avatar}
              centerService.changeAvatar(info).then(res2 => {
                this.submitting = false
                if(res2.errorNo==0){
                  userInfo.avatar = avatar
                  this.$store.commit('setUserInfo', userInfo)
                  this.$emit('Skip', {key: 'majorInfo'})
                } else {
                  this.$Message.error(res2.errorMessage)
                }
              })
            } else {
              this.submitting = false
              this.$Message.error(res.errorMessage)
            }
          })
          .catch(error => {
            this.submitting = false
            // this.$Message.error(error.message)
            console.log(error.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.realAvatarWrap{
  position: relative;
  padding-right: 50%;
  margin-bottom: 20px;

  .fileBtn{
    position: absolute;
    width: 104px;
    height: 32px;
    opacity: 0;
    left: 0;
    top: 0;
    border-radius: 100px;
  }
  .floatRight{
    float: right;

    .smallerBtn, .largerBtn {
      display: inline-block;
      width: 30px;
      height: 30px;
      margin: 0 5px;
      background: no-repeat center;
      background-size: 15px;
      cursor: pointer;
      vertical-align: top;
      opacity: .6;
    }
    .smallerBtn {
      background-image: url(/img/dragonStar/small.jpg)
    }
    .largerBtn {
      background-image: url(/img/dragonStar/large.jpg)
    }
  }
  .avatar{
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    background: #dddddd;
    margin-top: 10px;

    .vue-cropper{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .rightAvatar{
    position: absolute;
    left: 55%;
    top: 14px;

    .realSize{
      width: 80px;
      height: 80px;
      background: #dddddd;
      margin-top: 10px;
      border-radius: 2px;
    }
  }
}
@media (max-width: 768px) {
  .realAvatarWrap {
    
    .floatRight{
      float: none;
      text-align: right;
    }
    .rightAvatar{
      top: 45px;
    }
  }
}
</style>